import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  termsModal: {
    fontFamily: "Inter",
    width: "700px",
    maxWidth: "700px",
    height: "90vh",
    maxHeight: "90vh",
    marginBottom: "28px",
    "& .modal-content": {
      borderRadius: "12px",
      boxShadow: `0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);`,
    },
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px",
      },
    },
    "& .modal-body": {
      padding: "0px 24px 24px",
    },
    "& .modal-footer": {
      padding: "8px 24px",
    },
    "& .modal-footer>*": {
      margin: "0px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    },
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "28px",
    height: "60vh",
    overflow: "auto",
    marginBottom: "8px",
    padding: "16px 10px 16px 0px",
    paddingRight: "10px",
    "& h3": {
      margin: "0px 0px -8px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      color: colors.gray900,
    },
    "& p": {
      margin: "0px",
      fontSize: "18px",
      fontWeight: "400",
      lineHeight: "28px",
      color: colors.mediumGrey,
    },
  },
});

export default styles;
